export default {
  verboseName: "Hotel",
  verboseNamePlural: "Hotels",
  modelName: "Hotel",
  modelNamePlural: "Hotels",
  appName: "hotels",
  propName: "hotel",
  propNamePlural: "hotels",
}
